import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Operario/editOperario`, method: 'POST', body: values, token: token})
}
